import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'İşleniyor': '#f59e0b', 'Tamamlandı': '#22c55e' };

@Component({
  selector: 'cam-cnc-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#4338ca">
      <div class="sk-icerik">
        <div class="sk-baslik">⚙️ CNC İşlem</div>
        @if (d('oncelik') && d('oncelik') !== 'Normal') {
          <div class="sk-alt" [style.color]="d('oncelik') === 'Acil' ? '#ef4444' : '#f59e0b'">⚡ {{ d('oncelik') }}</div>
        }
      </div>
      <div class="sk-sag">
        <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ sonDurum() }}</span>
      </div>
    </div>
  `,
})
export class CamCncKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  sonDurum = computed(() => this.d('durum') || 'Bekliyor');
  durumRenk = computed(() => DURUM_RENK[this.sonDurum()] || '#94a3b8');
}
